/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { __core_private__ as r } from '@angular/core';
export var /** @type {?} */ RenderDebugInfo = r.RenderDebugInfo;
export var /** @type {?} */ ReflectionCapabilities = r.ReflectionCapabilities;
export var /** @type {?} */ DebugDomRootRenderer = r.DebugDomRootRenderer;
export var /** @type {?} */ reflector = r.reflector;
export var /** @type {?} */ NoOpAnimationPlayer = r.NoOpAnimationPlayer;
export var /** @type {?} */ AnimationPlayer = r.AnimationPlayer;
export var /** @type {?} */ AnimationSequencePlayer = r.AnimationSequencePlayer;
export var /** @type {?} */ AnimationGroupPlayer = r.AnimationGroupPlayer;
export var /** @type {?} */ AnimationKeyframe = r.AnimationKeyframe;
export var /** @type {?} */ AnimationStyles = r.AnimationStyles;
export var /** @type {?} */ prepareFinalAnimationStyles = r.prepareFinalAnimationStyles;
export var /** @type {?} */ balanceAnimationKeyframes = r.balanceAnimationKeyframes;
export var /** @type {?} */ clearStyles = r.clearStyles;
export var /** @type {?} */ collectAndResolveStyles = r.collectAndResolveStyles;
//# sourceMappingURL=private_import_core.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/platform-browser/src/private_import_core.js
// module id = 232
// module chunks = 0